import { FormControl, FormHelperText, FormLabel } from "@mui/material";
import axios from "axios";
import { ErrorMessage } from "formik";
import { enqueueSnackbar } from "notistack";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import CustomAutocomplete from "../../../../../components/mui/form/autocomplete/autocomplete";
import { API } from "../../../../../helpers/constants";
import { handleAxiosErrors, logoutUnauthorizedUser } from "../../../../../helpers/errorHandling";
import { formControlDefaults } from "../../../../../helpers/theme/defaultProps";
import useUserAction from "../../../../../hooks/user/useUserAction";
import useUserData from "../../../../../hooks/user/useUserData";
import { ISSUES_FORM } from "../../../locales/namespaces";

const AssetAutoComplete = (props) => {
	const { value, formik, index, initialAssets } = props
	const { t } = useTranslation(ISSUES_FORM)

	return (
		<FormControl {...formControlDefaults}>
			<FormLabel>{t('Item')}</FormLabel>
			<CustomAutocomplete
				identifier={'id'}
				value={value}
				onChange={(evt, newValue, reason) => {
					if (reason === 'clear') {
						formik.setFieldValue(`assets[${index}].asset`, '')
					} else {
						formik.setFieldValue(`assets[${index}].asset`, newValue)
					}
				}}
				options={initialAssets}
				labelKey={'Description'}
				otherprops={{
					selectOnFocus: true,
					getOptionKey: (option) => (option.id)
				}}
			/>
		</FormControl>
	);
};

export default AssetAutoComplete